<div class="box">
  @if (logoUrl) {
    <img [src]="logoUrl" alt="Form logo" style="max-height: 40px; width: auto;">
  }

  <h2 class="title is-4">{{ title ?? ('landing.defaultTitle' | localize) }}</h2>
  <p class="subtitle is-6 mt-5">{{ description ?? ('landing.defaultDescription' | localize) }}</p>

  <p class="mb-4">{{ 'landing.checklistInstruction' | localize }}</p>

  <ul class="checklist">
    @for (item of checklistItems; track $index) {
      <li class="field">
        <label class="checkbox">
          <input type="checkbox"
                 [checked]="checkedState()[$index]"
                 (change)="onCheckboxChange($index, $event)">
          {{ item.label }}
        </label>
      </li>
    }
  </ul>

  <div class="field mt-5">
    <div class="control">
      <button class="button is-primary"
              [disabled]="!allChecked()"
              (click)="onStartSubmission()">
        {{ 'landing.button.start' | localize }}
      </button>
    </div>
  </div>
</div>
